import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import { useEffect } from "preact/hooks"

export function CategoryBody({ loading, foundProducts }) {
    // if (loading) return <Loader />
    const isMobile = window.innerWidth < 768;


    useEffect(()=>{
        const serp = document.querySelector(".ns-serp");
        if(serp){
            serp.addEventListener('keydown', function(e) {
                if (e.key === 'Enter') {
                  const active = document.activeElement;
                  
                  // Make sure the element supports click and is visible
                  if (active && typeof active.click === 'function') {
                    // Optional: check for roles or tag names if you want to limit scope
                    active.click();
                  }
                }
            });
        }
    }, [])

    return (
        foundProducts ? (
            <>
                <Toolbar isMobile={isMobile} />
                <SelectedFilters />
                <Products />
                <BottomToolbar />
                <section id="categorypage-nosto-1"></section>
            </>
        ) : (
            !loading && <NoResults />
        )
    );
}

export function CategoryBodyInfiniteScroll({ loading, foundProducts }) {
    const isMobile = window.innerWidth < 768;


    useEffect(()=>{
        const serp = document.querySelector(".ns-serp");
        if(serp){
            serp.addEventListener('keydown', function(e) {
                if (e.key === 'Enter') {
                  const active = document.activeElement;
                  
                  // Make sure the element supports click and is visible
                  if (active && typeof active.click === 'function') {
                    // Optional: check for roles or tag names if you want to limit scope
                    active.click();
                  }
                }
            });
        }
    }, [])

    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <Toolbar isMobile={isMobile} />
            <SelectedFilters />
            <Products />
            <BottomToolbar />
            <section id="categorypage-nosto-1"></section>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("category", CategoryBodyInfiniteScroll)
export default wrapContent("category", CategoryBody)
// export default wrapContent("category", CategoryBodyInfiniteScroll)
